import React, {Component} from 'react';
import {connect} from 'react-redux';
import stateLinker from '../../../utils/stateLinker';
import ContentEditable from '../../Helpers/ContentEditable';
import axios from 'axios';
import Dropzone from 'react-dropzone';
import ReactResizeDetector from 'react-resize-detector';
import { observer, inject,Observer } from 'mobx-react';
import { makeObservable, observable, reaction } from "mobx";
import { custom } from "../../../utils/linker";


class ChatPostForm extends Component {
  message='';
  files=[];
  upload_progress_compleated=0;
  posting=0;

  constructor(props) {
    super(props);
    makeObservable(this,{
      message:observable,
      files:observable,
      upload_progress_compleated:observable,
      posting:observable,
    });


    window.setMessage=(mess)=>{
      this.message=mess;
    };


    /*this.state = {
      message:'',
      files:[],
      upload_progress_compleated:0,
      posting:false,
    };*/
    this._lastHeight=0;
  }

  /*
  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.state.files.length !== prevState.files.length) {
      this.props.onNeedRescroll();
    }
    this.updateHeight();
  }
  */
  
  updateHeight() {
    return false;
    if(this.props.onHeightUpdate && this._lastHeight!==this._ref.clientHeight) {
      this._lastHeight=this._ref.clientHeight;
      this.props.onHeightUpdate(this._ref.clientHeight);
    }
  }
  componentDidMount() {
    this.updateHeight();
  }
  sendMessage() {
    if(!this._blockSend) {
      this._blockSend = true;
      this._messageInputRef.focusMe();

      let data = new FormData();
      data.append('message', this.message);
      let options={};

      if(this.files.length>0) {
        data.append('type', 'image');
        for(let i in this.files) {
          data.append('file[]', this.files[i]);
        }

        options={
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            this.upload_progress_compleated=percentCompleted;
          }
        };
        this.posting=true;
      }

      axios.post(`/api/privatechat/${this.props.chat_id}/messages`, data, options).then((data) => {
        this._blockSend = false;
        if (data.data.answer) {
          this.message='';
          this.posting=false;
          this.upload_progress_compleated=0;
          this.files=[];
        }
      });
    }
  }
  onDrop(files) {
    const allowTypes=[
      'image/jpeg',
      'image/png',
      'image/gif',
    ];
     for(let i in files) {
      if(allowTypes.indexOf(files[i].type)>-1) {
        this.files.push(files[i]);
      }
    }
    // console.log('acceptedFiles',acceptFiles);
    // console.log('files',files);
    // this.setState({ files:acceptFiles });

  }
  removeFile(index) {
    this.files.splice(index,1);
    // this.setState({ files:acceptFiles });
  }
  renderAttachedFiles() {
    if(this.files.length > 0) {
      const files=this.files.map((file,index)=>{
        return (
          <div key={index} style={{width: 40, height: 40, fontSize:0, backgroundImage:`url('${file.preview}')`, backgroundPosition:'center center', backgroundRepeat:'no-repeat', backgroundSize:'cover'}} className={"dib vat mright10 rad4 pr"}>
            <div className="pa pa-tr w1 mdi mdi-close fs20 lh10 pointer" onClick={()=>{ this.removeFile(index); }}></div>
          </div>
        )
      });
      return (
        <div className="vpadd5 hpadd10">
          {files}
        </div>
      )
    }
  }
  render() {
    return (
      <div className="bg-w1  solid1-top pr bo-w2" ref={(ref)=>{ this._ref=ref; }}>

          {this.renderAttachedFiles()}

          <Dropzone
            ref={(ref)=>{ this._dropzoneRef=ref; }}
            style={{}}
            onDrop={(files)=>{ this.onDrop(files); }}
            multiple={true}
            disableClick={true}
          >
            {({getRootProps, getInputProps, isDragActive}) => <Observer>{()=>{
              return (
                  <div className="up12 splice pr">
                    <div className="cell s-shrink">
                      <i className="mdi mdi-paperclip w4 fs24 padd5 pointer db lh10"
                         onClick={() => { this._dropzoneRef.open() }}>
                      </i>
                    </div>
                    <div className="cell s-auto">
                      <ReactResizeDetector handleHeight onResize={()=>{ this.props.onNeedRescroll(); }}>
                        <div style={{maxHeight:100 }} className={`ofa chatPostWrapper ${this.props.standalone?'fs15':'fs13'} `}>
                          <ContentEditable
                            ref={(ref)=>{ this._messageInputRef=ref; }}
                            className="mw100"
                            onEnter={()=>{ this.sendMessage(); }}
                            placeholder="Ваше сообщение"
                            {...custom(this,'message')}
                            /*html={this.state.message}
                            onChange={(newValue)=>{ this.setState({ message:newValue }); }}*/
                          />
                        </div>
                      </ReactResizeDetector>
                    </div>
                    {this.message || this.files.length?(
                      <div className="cell s-shrink">
                        <i className="mdi mdi-send pc1 fs24 padd5 pointer db lh10" onClick={()=>{ this.sendMessage(); }}></i>
                      </div>
                    ):null}
                    {isDragActive?(
                      <div className="pa pa-tl w100 h100 bg-w1-op50 tac bo-w2 dashed2">
                        <div className="up12 splice h100">
                          <div className="cell s-12 s-middle">
                            Drop here
                          </div>
                        </div>
                      </div>
                    ):null}
                  </div>
              )
            }}</Observer>}
          </Dropzone>


        {this.posting?(
          <div className="pa pa-tl w100 h100 bg-w1-op50 tac">
            <div className="up12 margin h100">
              <div className="cell s-12 s-middle">
                {this.upload_progress_compleated<100?(
                  <span>
                    Отправка: {this.upload_progress_compleated}%
                  </span>
                ):(
                  <span>
                    Обработка...
                  </span>
                )}
              </div>
            </div>
          </div>
        ):null}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
  
  }
}

export default observer(ChatPostForm);